import {
  getString,
} from "@surya-digital/leo-ts-types";

export interface SurveyNameDTO {
  name: string;
}

export class SurveyName {
  readonly isSurveyNameSurveyName: boolean = true;

  readonly name: string;

  static readonly constraints = {
    "name": {
      "minSize": 4,
      "maxSize": 128,
      
      
      
      
    }
  }

  constructor(
  name: string
  ) {
    SurveyName.validateName(name);
    this.name = name;
  }

  static fromDTO(dto: SurveyNameDTO): SurveyName {
    const name = getString(dto, "name", InvalidSurveyNameNameError);
    return new SurveyName(
      name
    );
  }

  toDTO(): SurveyNameDTO {
    const dto: SurveyNameDTO = {
        name: this.name
    };
    return dto;
  }
  private static validateName = (name: string): void => {
    if(name.length < 4) {
      throw new InvalidSurveyNameNameMinSizeError(
        4,
        `Attribute name is too short. Size is ${name.length}. Min size is 4.`
      );
    }
    if(name.length > 128) {
      throw new InvalidSurveyNameNameMaxSizeError(
        128,
        `Attribute name is too long. Size is ${name.length}. Max size is 128.`
      );
    }
      if(name.trim().length === 0) {
        throw new InvalidSurveyNameNameNonEmptyError(
          `Attribute name cannot be an empty string.`
        );
      }
  }
  
}

SurveyName.prototype.toString = function toString(): string {
  return `SurveyName(name='${this.name}')`;
};

export class InvalidSurveyNameError extends Error {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyNameError";
  }
}
export class InvalidSurveyNameNameError extends InvalidSurveyNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyNameNameError";
  }
}

export class InvalidSurveyNameNameMaxSizeError extends InvalidSurveyNameNameError {
  readonly maxSize: number;
  constructor(maxSize: number, message?: string) {
    super(message);
    this.maxSize = maxSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyNameNameMaxSizeError";
  }
}

export class InvalidSurveyNameNameMinSizeError extends InvalidSurveyNameNameError {
  readonly minSize: number;
  constructor(minSize: number, message?: string) {
    super(message);
    this.minSize = minSize;
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyNameNameMinSizeError";
  }
}

export class InvalidSurveyNameNameNonEmptyError extends InvalidSurveyNameNameError {
  constructor(message?: string) {
    super(message);
    Object.setPrototypeOf(this, new.target.prototype);
    this.name = "InvalidSurveyNameNameNonEmptyError";
  }
}
